var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestionCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m6 6.356.664-.369c.33-.184.536-.533.536-.912-.039-.63-.58-1.11-1.21-1.076a1.17 1.17 0 0 0-1.19.907"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 4.502,
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6.05 7.95a.05.05 0 1 1-.1 0 .05.05 0 0 1 .1 0"
})));
export default SvgQuestionCircle;